// extracted by mini-css-extract-plugin
module.exports = {"refresh-btn":"refreshButton_refresh-btn__1O-et","spin":"refreshButton_spin__2HJfu"};